import { render, staticRenderFns } from "./observed_preface1.vue?vue&type=template&id=46516ce2&"
import script from "./observed_preface1.vue?vue&type=script&lang=js&"
export * from "./observed_preface1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports